import React, { createContext, useContext, useState, ReactNode } from 'react';

interface RightDrawerContextType {
    isOpen: boolean;
    openDrawer: () => void;
    closeDrawer: () => void;
    toggleDrawer: () => void;
}

const RightDrawerContext = createContext<RightDrawerContextType | undefined>(undefined);

interface RightDrawerProviderProps {
    children: ReactNode;
}

export const RightDrawerProvider: React.FC<RightDrawerProviderProps> = ({ children }) => {
    const [isOpen, setIsOpen] = useState<boolean>(false);

    const openDrawer = () => setIsOpen(true);
    const closeDrawer = () => setIsOpen(false);
    const toggleDrawer = () => setIsOpen((prev) => !prev);

    return (
        <RightDrawerContext.Provider value={{ isOpen, openDrawer, closeDrawer, toggleDrawer }}>
            {children}
        </RightDrawerContext.Provider>
    );
};


export const useRightDrawer = (): RightDrawerContextType => {
    const context = useContext(RightDrawerContext);


    if (context === undefined) {
        throw new Error('useRightDrawer must be used within a RightDrawerProvider');
    }

    return context;
};